import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import mapModule from "highcharts/modules/map";
import proj4 from "proj4";

mapModule(Highcharts);
window.proj4 = window.proj4 || proj4;

var internalChart

export default class MapPieChart extends React.Component {
    constructor(props) {
        super(props);

        Highcharts.seriesType(
            "mappie",
            "pie",
            {
                center: null, // Can't be array by default anymore
                states: {
                    hover: {
                        halo: {
                            size: 5
                        }
                    }
                },
                linkedMap: null, // id of linked map
                dataLabels: {
                    enabled: false,
                },
                // innerSize: '60%',
                // enableMouseTracking: false,
            },
            {
                init: function () {
                    Highcharts.Series.prototype.init.apply(this, arguments);
                    // Respond to zooming and dragging the base map
                    Highcharts.addEvent(this.chart.mapView, "afterSetView", () => {
                        this.isDirty = true;
                    });
                },
                render: function () {
                    const series = this,
                        chart = series.chart,
                        linkedSeries = chart.get(series.options.linkedMap);
                    Highcharts.seriesTypes.pie.prototype.render.apply(this, arguments);
                    if (series.group && linkedSeries === "map") {
                        series.group.add(linkedSeries.group);
                    }
                },
                getCenter: function () {
                    const options = this.options,
                        chart = this.chart,
                        slicingRoom = 2 * (options.slicedOffset || 0);
                    if (!options.center) {
                        options.center = [null, null]; // Do the default here instead
                    }
                    // Handle lat/lon support
                    if (options.center.lat !== undefined) {
                        const projectedPos = chart.fromLatLonToPoint(options.center),
                            pixelPos = chart.mapView.projectedUnitsToPixels(projectedPos);

                        options.center = [
                            pixelPos.x, // - chart.plotLeft,
                            pixelPos.y //- chart.plotTop
                        ];
                    }
                    // Handle dynamic size
                    if (options.sizeFormatter) {
                        options.size = options.sizeFormatter.call(this);
                    }
                    // Call parent function
                    var result = Highcharts.seriesTypes.pie.prototype.getCenter.call(this);
                    // Must correct for slicing room to get exact pixel pos
                    result[0] -= slicingRoom;
                    result[1] -= slicingRoom;
                    return result;
                },
                translate: function (p) {
                    this.options.center = this.userOptions.center;
                    this.center = this.getCenter();
                    return Highcharts.seriesTypes.pie.prototype.translate.call(this, p);
                }
            }
        );

        this.state = { options: this.updateData() }
    }

    draw_pie(chart, maxVotes, labels, colors) {
        // Add the pies after chart load, optionally with offset and connectors
        Highcharts.each(chart.series[0].points, function (state) {
            if (!state.id || !state.sumVotes || !state.properties) {
                return; // Skip points with no data, if any
            }

            const pieOffset = state.pieOffset || {},
                centerLat = parseFloat(state.properties.latitude),
                centerLon = parseFloat(state.properties.longitude);

            // Add the pie for this state
            chart.addSeries(
                {
                    clip: true,
                    type: "mappie",
                    name: state.id,
                    zIndex: 6, // Keep pies above connector lines
                    sizeFormatter: function () {
                        const zoomFactor = chart.mapView.zoom / chart.mapView.minZoom;

                        return Math.max(
                            (this.chart.chartWidth / 30) * (1 / zoomFactor), // Min size

                            ((this.chart.chartWidth / 18) * (1 / zoomFactor) * state.sumVotes) /
                            maxVotes
                        );
                    },
                    tooltip: {
                        // Use the state tooltip for the pies as well
                        pointFormatter: function () {
                            var obj = {
                                id: state.id,
                                hoverVotes: this.name,
                                sumVotes: state.sumVotes
                            }
                            labels.forEach((label) => {
                                obj[label] = state[label]
                            })
                            return state.series.tooltipOptions.pointFormatter.call(obj);
                        }
                    },
                    data: labels.map((label, index) => {
                        return {
                            name: label,
                            y: state[label],
                            color: colors[index]
                        }
                    }),
                    center: {
                        lat: centerLat + (pieOffset.lat || 0),
                        lon: centerLon + (pieOffset.lon || 0)
                    },
                },
                false
            );
        });
        chart.redraw();
    }

    updateData() {
        const { labels, colors, colorsmap, data, maxVotes } = this.getData();
        const page = this

        // Build the chart
        return {
            exporting: {
                enabled: true
            },
            chart: {
                // backgroundColor: 'rgba(50,50,50,0.5)',
                animation: false,
                events: {
                    load: function () {
                        page.draw_pie(this, maxVotes, labels, colors);
                        this.mapZoom(page.props.zoom[0], page.props.zoom[1], page.props.zoom[2])
                    },
                    redraw: function () {
                        internalChart = this;
                    }
                }
            },

            title: '',

            colorAxis: {
                dataClasses: labels.map((label, index) => {
                    return {
                        from: index,
                        to: index + 1,
                        color: colorsmap[index],
                        name: label
                    }
                })
            },

            mapNavigation: {
                enabled: true
            },
            // Limit zoom range
            yAxis: {
                minRange: 2300
            },

            tooltip: {
                useHTML: true
            },
            legend: {
                enabled: false
            },

            // Default options for the pies
            plotOptions: {
                mappie: {
                    borderColor: "rgba(50,50,50,0.4)",
                    borderWidth: 1,
                    tooltip: {
                        headerFormat: ""
                    },
                    events: {
                        click: function (e) {
                            page.props.drilldown(this.name)
                        }
                    },
                },
                series: {
                    events: {
                        click: function (e) {
                            page.props.drilldown(e.point.id)
                        }
                    },
                },
            },

            series: [
                {
                    mapData: this.props.map,
                    data: data,
                    name: "States",
                    borderColor: "#BBB",
                    showInLegend: false,
                    joinBy: ["name-TH", "id"],
                    keys: ["id"].concat(labels).concat([
                        "sumVotes",
                        "value",
                        "pieOffset"
                    ]),
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            if (this.point.properties) {
                                return (this.point.properties['name-Display'] === undefined ? this.point.properties['name-TH'] : this.point.properties['name-Display']) +
                                    (this.point.sumVotes ? '<br/>' : '')
                            }
                        },
                        style: {
                            fontSize: '15px'
                        },
                    },
                    tooltip: {
                        headerFormat: "",
                        pointFormatter: function () {
                            const sumfilms = labels.map((label) => {
                                return this[label]
                            }).reduce(function (a, b) {
                                return a + b;
                            }, 0)
                            var hoverVotes = this.hoverVotes; // Used by pie only
                            return (
                                "<b>" +
                                this.id +
                                "</b><br/>" +
                                Highcharts.map(
                                    labels.map((label, index) => {
                                        return [label, (this[label] / sumfilms) * 100, colors[index]]
                                    }).sort(function (a, b) {
                                        return b[1] - a[1]; // Sort tooltip by most votes
                                    }),
                                    function (line) {
                                        return (
                                            '<span style="color:' +
                                            line[2] +
                                            // Colorized bullet
                                            '">\u25CF</span> ' +
                                            // Party and votes
                                            (line[0] === hoverVotes ? "<b>" : "") +
                                            line[0] +
                                            ": " +
                                            Highcharts.numberFormat(line[1], 2) + '%' +
                                            (line[0] === hoverVotes ? "</b>" : "") +
                                            "<br/>"
                                        );
                                    }
                                ).join("") +
                                "<hr/>Total: " +
                                Highcharts.numberFormat(this.sumVotes, 0) +
                                ' Films'
                            );
                        }
                    }
                },
            ]
        };
    }

    getData() {
        const fulldata = this.props.data;

        const labels = fulldata.labels
        const colors = fulldata.pieColor
        const colorsmap = fulldata.mapColor

        const data = fulldata.datasets.map((dataset) => {
            return [dataset.label].concat(dataset.data)
            // return [dataset.label].concat([100, 100, 100, 100, 100, 100])
        }).map((row) => {
            var sum = 0
            var max = 0
            var max_index = 0
            row.forEach((col, index) => {
                if (index > 0) {
                    if (col > max) {
                        max = col
                        max_index = index - 1
                    }
                    sum += col
                }
            })
            return row.concat([sum, max_index])
        })

        let maxVotes = 0;
        // Compute max votes to find relative sizes of bubbles
        Highcharts.each(data, function (row) {
            maxVotes = Math.max(maxVotes, row[labels.length + 1]);
        });

        return { labels, colors, colorsmap, data, maxVotes }
    }

    componentDidUpdate(prevProps, prevStates, snapshot) {
        if (!this.props.display)
            return
        if (prevProps.data !== this.props.data) {
            console.log("Map Update!!!!!!!!!!!!!!", this.props.id)
            const option = this.updateData()
            this.setState({ options: option })
        }
        if (prevStates.options !== this.state.options) {
            console.log("Map Update!!!!!!!!!!!!!!", this.props.id)
            const { labels, colors, colorsmap, data, maxVotes } = this.getData();
            this.draw_pie(internalChart, maxVotes, labels, colors);
        }
        if (prevProps.zoom !== this.props.zoom) {
            console.log("Map Update!!!!!!!!!!!!!!", this.props.id)
            // zoom out ก่อน
            internalChart.mapZoom(100)
            // แล้วค่อย zoom in ในเขตสุขภาพนั้นๆ
            internalChart.mapZoom(this.props.zoom[0], this.props.zoom[1], this.props.zoom[2])
        }
    }

    render() {
        console.log(this.props.id, internalChart)
        return (
            <div style={{ display: (this.props.display ? 'inline' : 'none') }}>
                <HighchartsReact
                    updateArgs={[true, true, true]}
                    highcharts={Highcharts}
                    options={this.state.options}
                    containerProps={{
                        style: {
                            height: this.props.height,
                        }
                    }}
                    constructorType={"mapChart"}
                />
            </div>
        );
    }
}
